import apiClient from './Api';
const PREFIX = '/team';

const getTeamProfile = postData => {
  return apiClient({
    url: `${PREFIX}/profile`,
    method: 'POST',
    data: postData
  });
};

const editTeamProfile = postData => {
  return apiClient({
    url: `${PREFIX}/updateteam`,
    method: 'POST',
    data: postData
  });
};

const changeUserType = postData => {
  return apiClient({
    url: `${PREFIX}/changeusertype`,
    method: 'POST',
    data: postData
  });
};

const getTeamPaProfile = postData => {
  return apiClient({
    url: `${PREFIX}/paprofile`,
    method: 'POST',
    data: postData
  });
};

/* // NOT IN USE
const getTeamDdProfile = postData => {
  return apiClient({
    url: `${PREFIX}/ddprofile`,
    method: 'POST',
    data: postData
  });
};
*/

const getTeamEdProfile = postData => {
  return apiClient({
    url: `${PREFIX}/edprofile`,
    method: 'POST',
    data: postData
  });
};

const getTeamEditorProfileQueueWise = postData => {
  return apiClient({
    url: `${PREFIX}/queue-wise-editor-profile`,
    method: 'POST',
    data: postData
  });
};

const removeDealership = postData => {
  return apiClient({
    url: `${PREFIX}/removedealer`,
    method: 'POST',
    data: postData
  });
};

const TeamService = {
  getTeamProfile,
  editTeamProfile,
  getTeamPaProfile,
  getTeamEdProfile,
  // getTeamDdProfile,
  removeDealership,
  changeUserType,
  getTeamEditorProfileQueueWise
};

export default TeamService;
